<template>
  <v-btn
    class="link non-text-transformation"
    data-cy="dataCy"
    color="primary"
    outlined
    tile
    @click="handleClick"
  >
    {{ label }}
  </v-btn>
</template>

<script>
export default {
  name: 'SecondaryButton',
  props: ['dataCy', 'label'],
  methods: {
    handleClick() {
      this.$emit('onClick')
    },
  },
}
</script>
